import type { OddsType } from '@library/types/projection';

export const isGoblin = (oddsType?: OddsType) => oddsType === 'goblin';

export const isDemon = (oddsType?: OddsType) => oddsType === 'demon';

export const isStandard = (oddsType?: OddsType) => oddsType === 'standard';

export const isAdjustedOdds = (simsProbabilityOfMore?: number) =>
  !!(
    simsProbabilityOfMore &&
    (simsProbabilityOfMore <= 0.47 || simsProbabilityOfMore > 0.53)
  );
